import React, { Fragment, useContext } from "react";
import { Avatar, Badge, Menu, List } from "antd";
import {
    HomeOutlined,
    GiftOutlined,
    NotificationOutlined,
    SettingOutlined,
    LogoutOutlined,
    UserOutlined,
    ShoppingOutlined,
} from "@ant-design/icons";
import { makeStyles } from "@material-ui/styles";
import Hidden from "@material-ui/core/Hidden";
import { MenuContext } from "../../context/carritoContext";
import jwt_decode from "jwt-decode";
import aws from "../../config/aws";
import { Link, withRouter } from "react-router-dom";
import Search from "antd/lib/input/Search";
import NavbarResponsive from "./NavbarResponsive";
import { Divider } from "rc-menu";

const { SubMenu } = Menu;

function Navbar(props) {
    const { colores, datosContx } = useContext(MenuContext);
    const token = localStorage.getItem("token");
    var decoded = Jwt(token);
    /* let saldo = decoded && decoded.datos_socio ? decoded.datos_socio.saldodisponible : null */
    /* let linea = decoded && decoded.datos_socio ? decoded.datos_socio.tienelinea : false */

    function Jwt(token) {
        try {
            return jwt_decode(token);
        } catch (e) {
            return null;
        }
    }

    const useStyles = makeStyles({
        background: {
            backgroundColor: colores.navPrimary.background,
        },
        logoContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60px",
        },
        imgLogo: {
            maxWidth: "100%",
            maxHeight: "100%",
        },
    });

    const classes = useStyles();

    const { tienda } = datosContx;

    return (
        <Fragment>
            <Hidden mdUp>
                <NavbarResponsive className={classes.showMenuResponsive} />
            </Hidden>
            <Hidden smDown>
                <div
                    className={
                        classes.background + " d-flex " + classes.hiddenNavbar
                    }
                >
                    <div className={classes.logoContainer}>
                        {tienda && tienda.length && tienda[0].imagenLogo ? (
                            <img
                                className={classes.imgLogo}
                                alt="cristobal colon"
                                src={aws + tienda[0].imagenLogo}
                            />
                        ) : null}
                    </div>
                    <div className="flex-grow-1" />
                    <div style={{ minWidth: "25vw" }}>
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "60px" }}
                        >
                            <Search
                                className="search-nav-responsive"
                                placeholder="Buscar... "
                                onSearch={(value) =>
                                    props.history.push(`/searching/${value}`)
                                }
                            />
                        </div>
                    </div>
                    <div>
                        {/* <div className="d-flex justify-content-end mr-2">
              Zona Autlan de Navarro
            </div> */}
                        <Menu mode="horizontal" className={classes.background}>
                            <Menu.Item key="/" icon={<HomeOutlined />}>
                                Inicio
                                <Link to="/" />
                            </Menu.Item>
                            <Menu.Item key="/productos" icon={<GiftOutlined />}>
                                Productos
                                <Link to="/productos" />
                            </Menu.Item>
                            {datosContx.ofertas ? (
                                <Menu.Item
                                    key="/ofertas"
                                    icon={<NotificationOutlined />}
                                >
                                    Ofertas
                                    <Link to="/ofertas" />
                                </Menu.Item>
                            ) : null}
                            {!decoded || decoded.rol === true ? null : (
                                <Menu.Item
                                    className={
                                        classes.background + " " + classes.hover
                                    }
                                    key="/shopping_cart"
                                >
                                    <Badge count={datosContx.carritoCantidad}>
                                        <ShoppingOutlined
                                            style={{ fontSize: 22 }}
                                            className={
                                                classes.background +
                                                " " +
                                                classes.hover
                                            }
                                        />
                                        <Link to="/shopping_cart" />
                                    </Badge>
                                </Menu.Item>
                            )}
                            {token && decoded["rol"] === false ? (
                                <SubMenu
                                    icon={
                                        !decoded.imagen &&
                                        !decoded.imagenFireBase ? (
                                            <Avatar
                                                size="large"
                                                style={{
                                                    backgroundColor: "#87d068",
                                                }}
                                            >
                                                <p>
                                                    {decoded.nombre.charAt(0)}
                                                </p>
                                            </Avatar>
                                        ) : decoded.imagenFireBase ? (
                                            <Avatar
                                                size="large"
                                                src={decoded.imagenFireBase}
                                            />
                                        ) : (
                                            <Avatar
                                                size="large"
                                                src={aws + decoded.imagen}
                                            />
                                        )
                                    }
                                >
                                    {!decoded || decoded.rol === true ? null : (
                                        <List
                                            itemLayout="horizontal"
                                            style={{ margin: "8px" }}
                                        >
                                            <List.Item>
                                                <List.Item.Meta
                                                    title={`Hola, ${decoded.nombre}`}
                                                />
                                            </List.Item>
                                        </List>
                                    )}
                                    <Divider />
                                    {!decoded || decoded.rol === true ? (
                                        <Menu.Item key="" className="d-none" />
                                    ) : (
                                        <Menu.Item key="/pedidos">
                                            <ShoppingOutlined /> Mis Apartados
                                            <Link to="/pedidos" />
                                        </Menu.Item>
                                    )}
                                    <Menu.Item key="perfiles">
                                        <SettingOutlined />
                                        Mi cuenta
                                        <Link to="/perfiles" />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <div
                                            onClick={() => {
                                                localStorage.removeItem(
                                                    "token",
                                                );
                                                window.location.reload();
                                            }}
                                        >
                                            <LogoutOutlined />
                                            Cerrar Sesión
                                        </div>
                                    </Menu.Item>
                                </SubMenu>
                            ) : decoded && decoded["rol"] === true ? (
                                <SubMenu
                                    icon={
                                        !decoded.imagen ? (
                                            <Avatar
                                                size="large"
                                                style={{
                                                    backgroundColor: "#87d068",
                                                }}
                                            >
                                                <p>
                                                    {decoded.nombre.charAt(0)}
                                                </p>
                                            </Avatar>
                                        ) : (
                                            <Avatar
                                                size="large"
                                                src={aws + decoded.imagen}
                                            />
                                        )
                                    }
                                >
                                    <Menu.Item key="admin">
                                        <SettingOutlined />
                                        Panel de administrador
                                        <Link to="/admin" />
                                    </Menu.Item>
                                    <Menu.Item key="sesion">
                                        <div
                                            onClick={() => {
                                                localStorage.removeItem(
                                                    "token",
                                                );
                                                window.location.reload();
                                            }}
                                        >
                                            <LogoutOutlined />
                                            Cerrar Sesión
                                        </div>
                                    </Menu.Item>
                                </SubMenu>
                            ) : null}
                            {token === "" || token === null ? (
                                <Menu.Item key="entrar">
                                    <div>
                                        <UserOutlined
                                            style={{ fontSize: 27 }}
                                        />
                                    </div>
                                    <Link to="/entrar" />
                                </Menu.Item>
                            ) : null}
                        </Menu>
                    </div>
                </div>
            </Hidden>
        </Fragment>
    );
}

export default withRouter(Navbar);
